import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { HttpClickHandler } from 'src/app/directives/http-click.directive';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends BaseComponent implements OnInit {

  form: FormGroup;
  hidePassword: boolean;

  constructor(private dialog: MatDialog) {
    super();
    this.hidePassword = true;

    this.form = new FormGroup({
      username: new FormControl(null, Validators.required),
      password: new FormControl(null, Validators.required),
      unifiedLogin: new FormControl(false)
    });
  }

  ngOnInit(): void {
  }

  login(httpClickHandler: HttpClickHandler): void {
    if (this.form.invalid) {
      httpClickHandler.enable();
      return;
    }
    this.doLogin(this.form.value.username, this.form.value.password, this.form.value.unifiedLogin, httpClickHandler);
  }

  doLogin(username: string, password: string, unifiedLogin: boolean, httpClickHandler: HttpClickHandler) {
    this.authorizationService.login(username, password, unifiedLogin)
      .subscribe(response => {
        httpClickHandler.enable();
      }, error => {
        httpClickHandler.enable();
      });
  }

}
